var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoBurgerHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Burger_House",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 10.9 10.9",
    style: {
      enableBackground: "new 0 0 10.9 10.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3A291B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Burger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base_burger"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Body_burger"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Content_burger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.4,5.7h0.3V4.5h7.5v1.2h0.3c0.1,0,0.2,0,0.3,0.1V4.4H1.2v1.4C1.2,5.7,1.3,5.7,1.4,5.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,5.1H4.7C4.6,5.2,4.6,5.3,4.6,5.4c0,0.2-0.2,0.4-0.4,0.4C4,5.8,3.8,5.6,3.8,5.4c0-0.1,0-0.2-0.1-0.3H3.3 c0,0.1-0.1,0.2-0.1,0.3c0,0.5,0.4,0.9,0.9,0.9S5,5.9,5,5.4C5.1,5.3,5.1,5.2,5,5.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,5.1c-0.1,0-0.2,0.1-0.2,0.1l0,0v3.2c0,0.2-0.2,0.4-0.3,0.4C7.1,8.8,7,8.7,7,8.5V5.2c0,0,0-0.1-0.2-0.1 H6.3v3.5c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9V5.1H7.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,5.2c0,0,0-0.1-0.2-0.1H4.7C4.6,5.2,4.6,5.3,4.6,5.4s0,0.2-0.1,0.3H7V5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,5.1H7.8c-0.1,0-0.2,0.1-0.2,0.1l0,0v0.4h1.8c0.4,0,0.7,0.3,0.7,0.7C10.1,6.7,9.8,7,9.4,7H7.6v0.6h1.8 c0.7,0,1.3-0.6,1.3-1.3C10.7,5.7,10.1,5.1,9.4,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,7H1.4C1.1,7,0.8,6.7,0.8,6.3c0-0.4,0.3-0.7,0.7-0.7h2.4c-0.1,0-0.2-0.1-0.2-0.2s0-0.2-0.1-0.3H1.4 c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3H7V7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,8.2H1.7V7H1.4C1.3,7,1.2,7,1.2,6.9v1.5H7V8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,7H9.2v1.3H7.6v0.2h2.1V6.9C9.6,7,9.5,7,9.4,7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,8.2H7.6v0.2c0,0.1-0.1,0.3-0.2,0.3h2v0.4C9.4,9.6,9,10,8.5,10H2.3c-0.5,0-0.9-0.4-0.9-0.9V8.8h5.7 C7,8.7,7,8.6,7,8.5V8.2H1c-0.1,0-0.2,0.1-0.2,0.2v0.7c0,1,0.6,1.6,1.6,1.6h6.1c1,0,1.6-0.5,1.6-1.5V8.4C10,8.3,9.9,8.2,9.8,8.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Top_burger"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,0.1H4.2c-1.8,0-3.3,1.5-3.3,3.5v0.6c0,0.1,0.1,0.2,0.2,0.2h8.8c0.1,0,0.2-0.1,0.2-0.2V3.6 C10,1.7,8.5,0.1,6.7,0.1z M9.5,3.9H1.4V3.5c0-1.5,1.2-2.7,2.7-2.7h2.6c1.5,0,2.7,1.2,2.7,2.7v0.4H9.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_14"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 2.9,
    cy: 2.3,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5.4,
    cy: 2.3,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 7.9,
    cy: 2.3,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 6.7,
    cy: 1.7,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 4.2,
    cy: 1.7,
    r: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoBurgerHouse);
export default __webpack_public_path__ + "static/media/picto-burger-house.275e507ca70b362ddda9d8130e28ea19.svg";
export { ForwardRef as ReactComponent };